import {api} from './api';

export const truckAssignmentsApi = api.injectEndpoints({
    endpoints: (build) => ({
        updateTruckAssignment: build.mutation<any,any>({
            query: ({id, body}) => ({
                url: `/truckAssignments/${id}`,
                method: 'PUT',
                body,
            }),
        }),
    }),
});

export const {useUpdateTruckAssignmentMutation} = truckAssignmentsApi;
